import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Province } from "@models/province";
import {
  deleteRequest,
  fetchRequest,
  createRequest,
  updateRequest
} from "@actions/province";
import ProvinceForm from "@components/provinces/Form";
import provinceApi from "@api/province";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: Province[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class ProvinceFormPage extends React.Component<AllProps> {
  state = {
    province: null,
    province_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.province_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    provinceApi
      .getItem({
        params: {
          id: this.state.province_id
        }
      })
      .then(({ data }) => {
        this.setState({
          province: data
        });
      })
      .catch(error => console.log(error));
  };

  getContent = () => {
    if (this.state.province_id && !this.state.province) {
      return null;
    }

    return (
      <ProvinceForm
        province={this.state.province}
        intl={this.props.intl}
        listUrl={"/provinces"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ provinces }: ApplicationState) => ({
  loading: provinces.loading,
  errors: provinces.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ProvinceFormPage));
